import { render, staticRenderFns } from "./ExportPromoCode.vue?vue&type=template&id=2b96521e"
import script from "./ExportPromoCode.vue?vue&type=script&lang=ts"
export * from "./ExportPromoCode.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports